import React from "react";
import FunctionalPage from "./FunctionalPage";
import DashBoards from "../components/dashboard/DashBoards";
import { IS_HEAD } from "../permissions/roleTypes";
import { useSelector } from "react-redux";
import { NotFound } from "./NotFoundPage";

const DashBoardsPage = () => {
  const { roles } = useSelector((state) => state.currentUser);

  return (
    <>
      {IS_HEAD(roles) && (
        <FunctionalPage title={"tableaux de bord"} component={<DashBoards />} />
      )}

      {!IS_HEAD(roles) && (
        <FunctionalPage title={""} component={<NotFound />} />
      )}
    </>
  );
};

export default DashBoardsPage;
